import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-flip';
import { EffectFlip, Autoplay } from 'swiper';

export default function SliderWords() {

 const { t } = useTranslation();
 const sliderWords = t('banner_accion.service_items', { returnObjects: true })


  return (
    <>
      <Swiper
        effect={'flip'}
        direction={'vertical'}
        autoplay={{ delay: 2000 }}
        modules={[EffectFlip, Autoplay]}
        className="slider-words"
      >
        {
          sliderWords.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <h3 className='bg-darkblue w_color'>{item}</h3>
              </SwiperSlide>
            )
          })

        }
      </Swiper>
    </>
  );
}
